import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const QRCodeGenerationViewModule = new Module({
  id: 'QR-CODE-GENERATION:VIEW:*',
  name: 'Item QR',
  label: 'QR Code Generation',
  path: 'qr-code-generation',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/QRCodeGeneration/View'))
  ),
  actions: {
    view: {
      id: 'QR-CODE-GENERATION:VIEW:*',
      name: 'VIEW',
      label: 'View'
    }
  }
});

const QRCodeGenerationModules = [QRCodeGenerationViewModule];

export default new ModuleBundle('QRCodeGeneration', QRCodeGenerationModules);
